import { ReactComponent as Sop } from "./svg/sop.svg";

export const IconOnSop = () => <Sop />;
